module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "images-loaded",
      rawName: "v-images-loaded",
      value: (_vm.loadApp),
      expression: "loadApp"
    }],
    ref: "app",
    class: [{
      alertState: _vm.alertIsVisible
    }, {
      disabled: _vm.isDisabled
    }],
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.isLoading) ? _c('miniloader', {
    ref: "loader"
  }) : _vm._e()], 1), _vm._v(" "), _c('notification'), _vm._v(" "), _c('topbar'), _vm._v(" "), _c('menuview'), _vm._v(" "), (!_vm.isThankyou) ? _c('chooseconf', {
    ref: "chooseconf"
  }) : _vm._e(), _vm._v(" "), _c('view-element', {
    attrs: {
      "name": "instructions"
    }
  }, [_c('instructions')], 1), _vm._v(" "), _c('view-element', {
    attrs: {
      "name": "home"
    }
  }, [_c('home')], 1), _vm._v(" "), _c('view-element', {
    attrs: {
      "name": "uprights"
    }
  }, [_c('uprights')], 1), _vm._v(" "), _c('view-element', {
    attrs: {
      "name": "elements"
    }
  }, [_c('elements')], 1), _vm._v(" "), _c('permanent-view', {
    attrs: {
      "name": "details"
    }
  }, [_c('detailsview')], 1), _vm._v(" "), _c('view-element', {
    attrs: {
      "name": "thankyou"
    }
  }, [_c('thankyou')], 1), _vm._v(" "), _c('loader'), _vm._v(" "), _c('tab-bar', [_c('span', {
    staticClass: "h6 medium currentview-title"
  }, [_vm._v("\n            " + _vm._s(_vm.currentViewTitle) + "\n        ")]), _vm._v(" "), _c('go-back-btn'), _vm._v(" "), _c('continue-btn')], 1), _vm._v(" "), _c('alert')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a038289"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/app.vue
// module id = 619
// module chunks = 0